module.exports = __webpack_public_path__ + "img/yezi4.df2a2dda.png";